







































































































































































































































































































































































































































































































































































































const getActiveNum = (params: string) => {
  const mapArr = [
    {
      name: 'third',
      num: 1, // 已申请
    },
    {
      name: 'first',
      num: 2, // 待审批
    },
    {
      name: 'second',
      num: 3, // 已审核
    }
  ];
  const item = mapArr.find((item: any) => item.name === params);
  return item ? item.num : 1;
}
import { Component, Vue, Provide } from "vue-property-decorator";
import {
  jsIntString,
  valueOrNull,
  arrayOrNull,
  timerangeParameter,
  timeFormat,
  downloadFile,
} from "@/utils";
// import { PageMixin } from "@/mixin/Page";
import { pagnition } from "@/utils/commonConfig";
import AppliedIndex from './components/AppliedIndex.vue'

@Component({
  name: "CombinationProperty",
  components: {
    approveComponent: () => import("../applicationReview/components/approve.vue"),
    repaymentPlanComponent: () =>
      import("../applicationReview/components/repaymentPlan.vue"),
    appliedIndex: AppliedIndex,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private activeName: string = "third"; //tab index
  @Provide() private waitApprovalList: any = []; //待审核数据
  @Provide() private alApprovalList: any = []; //已审核数据
   @Provide() private passAutomaticallyOptions: any = [
    { value: 1, name: 'dashbordDy.yes', },
    { value: 2, name: 'dashbordDy.no', },
   ];
   @Provide() private isRepayOption: any = [
    { value: 1, name: 'dashbordDy.yes', key: '1-1' },
    { value: 2, name: 'dashbordDy.no', key: '1-2' },
   ];
   //  审批状态选择 [1]-待审核，[6]-已失效，[2，3，4，5]-已完成
  @Provide() private statusListOption: any = [
    // { value: '1', name: 'applicationReview.Approve', key: '1-1' }, // 待审批
    { value: '6', name: 'applicationReview.Invalid', key: '1-2' }, // 失效
    { value: '2, 3, 4, 5', name: 'ticketWrh.alApproval', key: '1-3' }, // 完成
    // { value: 3, name: 'dashbordDy.yes', key: '1-4' }, // 拒绝
    // { value: 4, name: 'ticketLgy.Failed', key: '1-5' }, // 失败
    // { value: 5, name: 'ticketLgy.Success', key: '1-6' }, // 成功
    // { value: 6, name: 'ticketLgy.Invalid', key: '1-7' }, // 失效
   ];
   @Provide() private statusListOptionLabel: any = [
    { value: '1', name: 'ticketWrh.waitApproval', key: '1-1' }, // 待审批
    { value: '6', name: 'applicationReview.Invalid', key: '1-2' }, // 失效
    { value: '2, 3, 4, 5', name: 'ticketWrh.alApproval', key: '1-3' }, // 完成
   ];
  @Provide() private reduceForm: any = {
    reduceid: "",
    orderid: "",
    customerid: "",
    applytime: "",
    passAutomatically:'',
    AppName:"",
  }; //搜索form
  @Provide() private rules: any = {
    applytime: [{ required: true, message: "pls select Apply Time", trigger: "blur" }],
  };
  @Provide() private queryLoading: boolean = false;
  @Provide() private exportLoading: boolean = false;
  @Provide() private waitApprovalLoading: boolean = true;
  @Provide() private alApprovalLoading: boolean = false;
  //componnet
  @Provide() private approvedtype: any = '';
  @Provide() private repaymentPlanData: any = []; // 还款按钮单期数据
  @Provide() private repayplanstageList: any = []; // 还款按钮分期数据
  @Provide() private isMask: boolean = false; // 展示审核弹窗
  @Provide() private isRepaymentMask: boolean = false; // 展示还款计划弹窗
  @Provide() private isApproveActionDone: boolean = false; // 审核按钮loading
  @Provide() private isRepaymentPlanActionDone: boolean = false; // 还款按钮loading
  @Provide() private ApproveProp: {
    Id: number;
    reduceid: number;
    list: any[];
  } | null = null; // 展示审核弹窗
  @Provide() private AppOpnList: any = [];
  @Provide() private AppName: any = "";
  // dialog  数据
  @Provide() private dialogVisible: boolean = false;
  @Provide() private dialogType: string = "";
  @Provide() private dialogTitle: string = "";
  @Provide() private applyReason: string = "";
  @Provide() private reduceAuditList: any = [];
  @Provide() private reduceapply: any = {
    time: "",
    username: "",
  };

  // 分页
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;

  private created() {
    this.getReduceOrderList(1);
  }

  //tab change
  private tabChange = this.debounce(function (this: any) {
    // tab 切换 重新获取数据

    this.pageIndex = 1;
    this.pageSize = 20;
    this.pagerCount = 0;
    this.waitApprovalList = [];
    this.alApprovalList = [];
    let waitAudit = getActiveNum(this.activeName);
    (this.$refs["reduceForm1"] as any).resetFields();
    (this.$refs["reduceForm2"] as any).resetFields();
    (this.$refs["reduceForm3"] as any).resetFields();
    this.reduceForm.applytime = "";
    this.getReduceOrderList(waitAudit);
  }, 1000);

  // search
  private queryReduceOrder(data: any) {
    (this.$refs[data] as any).validate((valid: any) => {
      if (valid) {
        this.pageIndex = 1;
        this.pageSize = 20;
        this.pagerCount = 0;
        this.alApprovalList = [];
        let waitAudit = getActiveNum(this.activeName);
        this.queryLoading = true;
        this.getReduceOrderList(waitAudit);
      } else {
        //  this.$message({
        //     type: "warning",
        //     message: "pls select Apply Time"
        // });
        return false;
      }
    });
  }

  // export
  private exportExcel(data: any) {
    (this.$refs[data] as any).validate((valid: any) => {
      if (valid) {
        let waitAudit = getActiveNum(this.activeName);
        this.exportExcelData(waitAudit);
      } else {
        return false;
      }
    });
  }

  private async exportExcelData(waitAudit: any) {
    const { getReduceListExcelReq, getReduceListExcelRequest }: any = await import(
      "@/request/getReduceList"
    );
    let res = await getReduceListExcelRequest.handleHttp(
      getReduceListExcelReq(this.getListarg(waitAudit)),
      null
    );
    if (res) {
      this.exportLoading = res ? res.loading : false;
      if (res && res.right) {
        if (res.filechunk) {
          let bStr = atob(res.filechunk),
            n = bStr.length,
            unit8Array = new Uint8Array(n);
          while (n--) {
            unit8Array[n] = bStr.charCodeAt(n);
          }
          const blob = new Blob([unit8Array], {
            type: "application/json",
          });
          downloadFile(blob, res.filename);
        }
      }
    }
  }

  // dialog close
  private handleClose() {
    this.dialogVisible = false;
  }

  // dialog confirm
  private handleApprovalDialog(dialogType: string, scope: any) {

    if (dialogType === "applyreason") {
      if (scope.row.applyreason === "" || scope.row.applyreason == 0) {
        return;
      } else {
        // this.dialogTitle = '申请理由'
        this.dialogTitle = this.$tc("applicationReview.ApplyReason");

        this.applyReason = scope.row.applyreason;
      }
    } else {
      this.dialogTitle = this.$tc("ticketWrh.approvalComment");
      // this.dialogTitle = '审批意见'

      //获取审批意见列表
      this.getReduceDetailList(scope);
    }
    this.dialogType = dialogType;
    this.dialogVisible = true;
  }

  //look current approval
  private currentApproval(scope: any) {
    scope.row.audituser = scope.row.nextauditusername
      ? scope.row.nextauditusername
      : "--";
  }

  //get reduce list
  private async getReduceDetailList(scope: any) {
    let _arg: any = {
      OrderId: String(scope.orderid),
      ReduceId: Number(scope.reduceid),
    };
    const { setGetReduceAuditListReq, GetReduceAuditListRequest }: any = await import(
      "@/request/getReduceList"
    );
    let res = await GetReduceAuditListRequest.handleHttp(
      setGetReduceAuditListReq(_arg),
      null
    );
    if (res && res.right) {
      this.reduceAuditList = res.auditlistList.map((item: any) => {
        let applytime = "";
        applytime = item.time ? timeFormat(item.time) : "--";
        this.$set(item, "applytime", applytime);
        return item;
      });
      this.reduceapply.time = timeFormat(res.reduceapply.time);
      this.reduceapply.username = res.reduceapply.username;
    }
  }

  //page change
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    let waitAudit = getActiveNum(this.activeName);
    this.getReduceOrderList(waitAudit);
  }

  //page prev
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      let waitAudit = getActiveNum(this.activeName);
      this.getReduceOrderList(waitAudit);
    }
  }

  //page next
  private handleNextChange(val: any) {
    let waitAudit = getActiveNum(this.activeName);
    this.getReduceOrderList(waitAudit);
  }

  //size change
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    let waitAudit = getActiveNum(this.activeName);
    this.getReduceOrderList(waitAudit);
  }

  //getList
  private async getReduceOrderList(waitAudit: any) {
    this.activeName === "first"
      ? (this.waitApprovalLoading = true)
      : (this.alApprovalLoading = true);
    const { setGetReduceListReq, getReduceListRequest }: any = await import(
      "@/request/getReduceList"
    );
    let res = await getReduceListRequest.handleHttp(
      setGetReduceListReq(this.getListarg(waitAudit)),
      null
    );
    if (this.AppOpnList.length==0){
      let AppOpnList=JSON.parse(res.applist)
      Object.keys(AppOpnList).forEach((item:any) => {
        this.AppOpnList.push({
          codeName: AppOpnList[item], code: null, channel: item
        })
      });
    }
   
    if (res && res.right) {
      this.queryLoading = false;
      let resultList = res.listList.map((item: any) => {
        for (let key in item["reducerecord"]) {
          if (item.hasOwnProperty(key) === false) {
            item[key] = item["reducerecord"][key];
          }
        }

        item.isRepaymentPlanActionDone = false;
        item.isApproveActionDone = false;
        item.audituser = this.$tc("ticketWrh.currentApproval");
        item.applytime = item.applytime ? timeFormat(item.applytime) : "--";
        item.lookReason =
          item.applyreason === "" || item.applyreason == 0
            ? "--"
            : this.$tc("ticketWrh.look");
        item.applyreason = item.applyreason? item.applyreason : "--";
        item.reduceAmount = item.reducetype === 1 ? item.reduceamount : item.reduceother;
        item.reduceType =
          item.reducetype === 1
            ? this.$tc("Deduction principle")
            : this.$tc("Deduction Interest");
        if (this.activeName !=='first') {
          this.approvedtype=item.approvedtype=item.approvedtype===0?"-":item.approvedtype===1?this.$tc("dashbordDy.yes"):this.$tc("dashbordDy.no")
          // item.applyreason=item.approvedtype===1?"--":item.approvedtype
        } 
        // 处理审批状态，转化成文案
        const rS = this.statusListOptionLabel.find((f: any) => f.value.includes(`${item.reducestatus}`))
        item.reducestatusLabel = rS ? this.$tc(rS.name) : '-'
        return item;
      });

      if (this.activeName === "first") {
        this.waitApprovalLoading = false;
        this.waitApprovalList = resultList;
      } else {
        this.alApprovalLoading = false;
        this.alApprovalList = resultList;
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    } else {
      this.waitApprovalLoading = false;
      this.alApprovalLoading = false;
    }
  }
  // list arg
  private getListarg(waitAudit: any) {
    return {
      ...this.reduceForm,
      OrderId: valueOrNull(jsIntString(this.reduceForm.orderid), this.reduceForm.orderid),
      CustomerId: valueOrNull(
        jsIntString(this.reduceForm.customerid),
        this.reduceForm.customerid
      ),
      ApplyTimeRange: valueOrNull(
        this.reduceForm.applytime,
        this.reduceForm.applytime ? timerangeParameter(this.reduceForm.applytime) : null
      ),
      ApprovedType:Number(this.reduceForm.passAutomatically),
      TypeList: null,
      StatusList: this.reduceForm.StatusList ? this.reduceForm.StatusList.split(',') : null,
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      WaitAudit: waitAudit, // 1 待审批  2 已审批
      reduceid: this.reduceForm.reduceid ? this.reduceForm.reduceid : 0,
    };
  }

  // 审核处理
  private approveAction(row: any) {
    this.ApproveProp = {
      Id: row.id,
      list: row.reduceotherlistList,
      reduceid: row.reduceid,
    };
    this.isMask = true;
    row.isApproveActionDone = true;
  }

  // 查看还款计划
  private checkRepaymentPalnAction(row: any) {
    row.isRepaymentPlanActionDone = true;
    this.getReduceDetailuest(row);
  }

  // 减免审核详情
  private async getReduceDetailuest(row: any) {
    const { setGetReduceDetailReq, getReduceDetailRequest }: any = await import(
      "@/request/getReduceList"
    );
    let data = await getReduceDetailRequest.handleHttp(
      setGetReduceDetailReq({
        OrderId: row.orderid,
      }),
      null
    );
    row.isRepaymentPlanActionDone = data ? data.loading : false;
    if (data && data.right) {
      this.isRepaymentMask = true;
      // 单期还款计划
      if (data.repayplan && data.repayplan.repaydate) {
        this.repaymentPlanData = data.repayplan;
        this.repaymentPlanData.repaydate =
          this.repaymentPlanData.repaydate &&
          timeFormat(this.repaymentPlanData.repaydate);
        if (data.repayplan.extrafiled) {
          this.repaymentPlanData.group =
            JSON.parse(data.repayplan.extrafiled) &&
            JSON.parse(data.repayplan.extrafiled).group;
        }
      }
      // 分期还款计划
      if (data.repayplanstageList) {
        this.repayplanstageList = data.repayplanstageList;
        this.repayplanstageList.forEach((item: any) => {
          item.repaydate = item.repaydate && timeFormat(item.repaydate);
          item.cleartime = item.cleartime ? timeFormat(item.cleartime) : "-";
          if (item.extrafiled) {
            item.group = JSON.parse(item.extrafiled) && JSON.parse(item.extrafiled).Group;
          }
          return item;
        });
      }
    }
  }

  // 关闭还款计划弹框
  private hideRepaymentDialog(arg: any) {
    this.isRepaymentMask = false; // 无论是否，都默认关闭遮罩层
  }

  // 关闭审核操作弹框
  private hideDialog(arg: any) {
    // 如果是正常提交的返回，hidden为true为提交了审核操作，此时需要重新请求接口获取数据，刷新当前记录
    if (arg.hidden) {
      this.pageIndex = 1;
      let waitAudit = getActiveNum(this.activeName);
      this.getReduceOrderList(waitAudit);
    }
    this.isMask = false; // 无论是否，都默认关闭遮罩层
  }

  private debounce(func: any, wait: any) {
    let timeout: any;
    let that = this;
    return function () {
      const args = [...arguments];
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(that, args); //改变this的指向，或者写成箭头函数传入this,此时指针指向上下文
      }, wait);
    };
  }
}
